import { LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarBoardAssets" */ './lazyIndex')
);

export function preLoadCalendarBoardAssets() {
    lazyModule.import();
}

export const ASSET_REGISTRY = new LazyImport(lazyModule, m => m.ASSET_REGISTRY);
